import React from 'react';
import { adaptPayLetterFailProps } from './PayLetterFail.adapter';
import PayLetterFail from './PayLetterFail';

/**
 * PayLetter Fail 에디터 컴포넌트
 * 에디터 환경에서 PayLetter Fail 컴포넌트를 표시하기 위한 래퍼
 */
const PayLetterFailEditor: React.FC<any> = (props) => {
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptPayLetterFailProps({
    ...props,
    isEditor: true
  });

  // 에디터 전용 props 분리
  const { isSelected, isPreview, updateComponent, viewMode, ...componentProps } = adaptedProps as any;

  return (
    <div className="payletter-fail-editor-wrapper">
      <PayLetterFail {...componentProps} />
    </div>
  );
};

export default PayLetterFailEditor; 